import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  title: {
    fontWeight: theme.typography.fontWeightLight,
    fontSize: theme.typography.h6.fontSize,
    marginBottom: 12,
  },
}))
